import { Component } from 'react';
import Transitions from '../../Transitions/Transitions';
import './Home.css';

export default class Home extends Component {
  render() {
    return (
      <Transitions>
        <div className="main-page">
          <div className='inner'>
            <div className='wallpaper'>
              <div className='image' />
            </div>
          </div>
        </div>
      </Transitions>
    )
  }
};